export default __webpack_public_path__ + "static/media/rw-4.c984c8ad.png";